import axios from '../../../axios';
import IFileInfoDTO from '../../awsS3Service/types/IFileInfoDTO';
import IBooleanQueryBuilderDTO from '../types/IBooleanQueryBuilderDTO';
import IClientDTO from '../types/IClientDTO';
import IClientRecruiterDTO from '../types/IClientRecruiterDTO';
import IJDGeneratorDTO from '../types/IJDGeneratorDTO';
import IJDParserDTO from '../types/IJDParserDTO';
import IJob from '../types/IJob';
import IJobDescriptionParserInputDTO from '../types/IJobDescriptionParserInputDTO';
import IJobFieldSettings from '../types/IJobFieldSettings';
import IJobSearchFilterDTO from '../types/IJobSearchFilterDTO';
import ISimilarJobsJobSearchQuery from '../types/ISimilarJobsJobSearchQuery';

const url = '/jobsearch/api/';
const wsParserUrl = '/wsaiinfinity/wisestep-parsers/';

const wsUtilityUrl = '/wsaiinfinity/wisestep-utility/gpt-generator';

const wsFeeArrangement = '/candidatesearch/api/arrangement';

export const generateJobCode = () => axios.get(`${url}jobs/generatejobcode`);

export const indexJob = (job: IJob) => axios.put(`${url}jobs`, job);

export const getSkillsSuggestions = (skill: string) =>
  axios.get(`${url}jobs/suggestions/skill?skill=${skill}`);

export const getClientSuggestions = (client: string) =>
  axios.get(`${url}jobs/suggestions/client?clientName=${client}`);

export const getClientJobCodeSuggestions = (clientJobCode: string, clientName: string) =>
  axios.get(
    `${url}jobs/getClientJobCodeSuggetions?clientJobCode=
        ${clientJobCode}&companyName=${clientName}`
  );

export const getJobByCompanyNameAndClientJobCode = (clientName: string, clientJobCode: string) =>
  axios.get(`${url}jobs/jobbyclientjobcode/${clientName}/${clientJobCode}`);

export const getClientRecruiterNameSuggestions = (
  clientRecruiterName: string,
  companyName: string
) =>
  axios.get(
    `${url}jobs/suggestions/client-recruiter-name?clientRecruiterName=${clientRecruiterName}&companyName=${companyName}`
  );

export const getTagsSuggetions = (tagPrefix: string) =>
  axios.get(`${url}jobs/suggestions/tag?tag=${tagPrefix}`);

export const saveJobFieldSettings = (jobFieldSettings: IJobFieldSettings) =>
  axios.post(`${url}jobs/save-job-field-settings`, jobFieldSettings);

export const getJobFieldSettings = () => axios.get(`${url}jobs/get-job-field-settings`);

export const getJobsFromAdvancedQuery = (query: IJobSearchFilterDTO) =>
  axios.post(`${url}_search/jobs/advanced`, query);

export const getAssignedJobs = (query: IJobSearchFilterDTO) =>
  axios.post(`${url}_search/jobs/assignedto`, query);

export const getJobById = (id: string) => axios.get(`${url}jobs/${id}`);

export const pinJob = (id: string) => axios.get(`${url}jobs/pin-job/${id}`);

export const removePinJob = (id: string) => axios.get(`${url}jobs/remove-pin-job/${id}`);

export const getAllPinJobs = () => axios.get(`${url}jobs/get-pin-jobs`);

export const queryAllPinnedJobs = () => axios.post(`${url}_search/jobs/pinned-jobs`);

export const regenerateBooleanQuery = (jobId: string) =>
  axios.post(`${url}jobs/regenerate-boolean-query/${jobId}`);

export const presignedURLForJDFileUpload = (fileInfoDTO: IFileInfoDTO) =>
  axios.post(`${url}jobs/jd/presigned-url-for-put`, fileInfoDTO);

export const uploadJDStringToS3AsFile = (jobDesParserInputDTO: IJobDescriptionParserInputDTO) =>
  axios.post(`${url}jobs/jd/text-to-s3file`, jobDesParserInputDTO);

export const saveJobToJobShare = (jobIds: string) =>
  axios.post(`${url}jobs/save-job-to-jobshare/${jobIds}`);

export const saveJobShareContactPerson = (jobIds: string) =>
  axios.post(`${url}jobs/save-jobshare-contact-person/${jobIds}`);

export const getJobCountByRecruiterIds = (recruiterEmailIds: string[]) =>
  axios.get(`${url}jobs/get-count-by-recruiters?recruiterIds=${recruiterEmailIds}`);

export const updateAddToCareerPage = (jobId: string, addToCareerPage: boolean) =>
  axios.get(`${url}jobs/update-add-to-career-page/${jobId}/${addToCareerPage}`);

export const indexAddToAdminCareerPage = (jobId: string, addToAdminCareerPage: boolean) =>
  axios.get(`${url}jobs/index-add-to-admin-career-page/${jobId}/${addToAdminCareerPage}`);

export const searchClientsByName = (query: string, page: number, size: number, sort: string[]) =>
  axios.get(
    `${url}jobs/client/search-by-name?query=${query}&page=${page}&size=${size}&sort=${sort}`
  );

export const searchClientsByNameExactly = (
  query: string,
  page: number,
  size: number,
  sort: string[]
) =>
  axios.get(
    `${url}jobs/client/search-by-name-exactly?query=${query}&page=${page}&size=${size}&sort=${sort}`
  );

export const indexClient = (client: IClientDTO) => axios.put(`${url}jobs/client`, client);

export const indexClientRecruiter = (clientRecruiterDTO: IClientRecruiterDTO) =>
  axios.put(`${url}jobs/client-recruiter`, clientRecruiterDTO);

export const searchClientRecruitersByEmail = (
  query: string,
  companyName: string,
  page: number,
  size: number,
  sort: string[]
) =>
  axios.get(
    `${url}jobs/client-recruiter/search-by-email?query=${query}&page=${page}&size=${size}&sort=${sort}&companyName=${companyName}`
  );

export const searchClientRecruitersByName = (
  query: string,
  companyName: string,
  page: number,
  size: number,
  sort: string[]
) =>
  axios.get(
    `${url}jobs/client-recruiter/search-by-name?query=${query}&page=${page}&size=${size}&sort=${sort}&companyName=${companyName}`
  );

export const getJobWithMatchingContent = (jobId: string) =>
  axios.get(`${url}jobs/job-matching-content/${jobId}`);

export const parseJD = (parserDTO: IJDParserDTO) =>
  axios.post(`${wsParserUrl}jd-parser`, parserDTO);

export const generateBooleanQuery = (booleanQueryBuilder: IBooleanQueryBuilderDTO) =>
  axios.post(`${wsParserUrl}boolean_query_builder`, booleanQueryBuilder);

export const getTeamsAndRecruiters = (id: string) =>
  axios.get(`${url}jobs/get-teams-and-recruiters-by-job-id/${id}`);

export const getJobStats = (query: IJobSearchFilterDTO) =>
  axios.post(`${url}jobs/status-count`, query);
export const closeJob = (job: IJob) => axios.put(`${url}jobs/close-job-for-assignments`, job);

export const getCompanyAutoSuggestions = (query: string) =>
  axios.get(`${url}jobs/suggestions/company-name?query=${query}`);

export const findSimilarJobs = (query: ISimilarJobsJobSearchQuery) =>
  axios.post(`${url}jobs/find-similar-jobs`, query);

export const reopenJobForAssigningRecruiters = (jobId: string) =>
  axios.put(`${url}jobs/reopen-job-for-assignments`, jobId);

export const getJobByJobCode = (jobCode: string) => axios.get(`${url}job-code/${jobCode}`);

export const downloadJobs = (allowedColumns: string[], query: IJobSearchFilterDTO) =>
  axios.post(`${url}_search/jobs/advanced.xls?filter=${JSON.stringify(allowedColumns)}`, query, {
    responseType: 'arraybuffer',
  });

export const jobDescriptionGenerator = (payload: IJDGeneratorDTO) =>
  axios.post(`${wsUtilityUrl}`, payload);

export const getJobsWorkAssignmentData = (jobIds: string[]) =>
  axios.get(`${url}jobs/job-work-assignment-data/${jobIds.toString()}`);

export const getPotentialRevenueForJobs = (jobIds: string[]) =>
  axios.get(`${wsFeeArrangement}/potential-revenue/${jobIds.toString()}`);

export const getJobCountByFeeArrangementId = (FeeArrangementIds: string[]) =>
  axios.post(`${url}jobs/fetch/fee-arrangement-count`, FeeArrangementIds);
